module.exports = __webpack_public_path__ + "assets/images/signup-organizer.a62ed9e493d32642cadd9d57089dcb39.svg";